import React from "react";

function CourtsDetails() {
  return <div>CourtsDetails</div>;
}

export default CourtsDetails;
